import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxSpinnerService } from "ngx-spinner";
import { CloudTypes, NodeTypes } from "../../../../core/models/globals";
import { NodeService } from "../../../../core/services/node.service";
import {
  AttachNodeAction,
  MultiNodeActionDTO,
  Node,
} from "src/app/core/models/node";
import { ActivatedRoute } from "@angular/router";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { DeploymentJsonBody, DeploymentParameter } from "src/app/core/models/deployment";

@Component({
  selector: 'app-sync-nodes',
  templateUrl: './sync-nodes.component.html',
  styleUrl: './sync-nodes.component.scss'
})
export class SyncNodesComponent implements OnInit{
  isFormSubmitted;
  filteredWorkstations: any[];
  multiSelectIndex = [];
  isSelectAll: boolean = false;
  depName;
  alreadyAttachedNodes = [];
  filterText: string = "";
  filtersApplied: boolean = false;
  availableVMs: any[] = [];
  selectedVMs: any[] = [];
  existingNodeGroupsList: string[] = this.data.nodeGroups ? this.data.nodeGroups.split(",") : [];

  constructor(
    public dialog: MatDialogRef<SyncNodesComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      depName: string;
      nodeGroups: string;
    },
    public nodeService: NodeService,
    private _spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar,
    private deploymentService: DeploymentService
  ) {}

  ngOnInit(): void {
    this._spinner.show("attachNode");
    this.depName = this.data.depName;
    this.syncKvmVirtualMachines();
    
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    if (this.multiSelectIndex.length == 0) {
      this._snackBar.open("Select node(s) to perform action", "Ok", {
        duration: 5000,
      });
      return;
    }

    this.selectedVMs = this.availableVMs.filter((vm) => this.multiSelectIndex.includes(vm.vmNames));
    let depParams: DeploymentParameter[] = [];
    depParams.push({ depKey: 'vmsToSync', depValue: JSON.stringify(this.selectedVMs) })
    var depJsonBody = new DeploymentJsonBody(depParams);
    
    try{
      this.nodeService.syncVirtualMachinesService(this.depName, this.selectedVMs)
      .subscribe({
        next: (data) => {
          this._spinner.hide("attachNode");
            if (data) {
              if(data?.actionMessage){
                this._snackBar.open(data?.actionMessage, "Ok", {
                  duration: 5000,
                });
                this.dialog.close(true);
              }
            }          
        },
        error: (err) => {
          this._spinner.hide("attachNode");
          console.error(err?.error);
          this._snackBar.open("Error syncing virtual machines.", "Ok", {
            duration: 5000,
          });
        },
        complete: () => {
          this._spinner.hide("attachNode");
          this.dialog.close(true);
        }
      })
    }
    catch(err){
      this._spinner.hide("attachNode");
      console.error(err);
      this._snackBar.open("Error syncing virtual machines.", "Ok", {
        duration: 5000,
      });
    }
    
  }

  onSelectAllCheckBox(event) {
    let filteredNodes = this.applyFilter();
    if (event.target.checked) {
      filteredNodes?.forEach((node, i) => {
        if (!this.multiSelectIndex.includes(node.vmNames)) {
          this.multiSelectIndex.push(node.vmNames);
        }
      });
      if (filteredNodes?.length == this.availableVMs.length) {
        this.isSelectAll = true;
      }
      return;
    } else {
      filteredNodes?.forEach((node, i) => {
        if (this.multiSelectIndex.includes(node.vmNames)) {
          let index = this.multiSelectIndex.indexOf(node.vmNames);
          if (index !== -1) {
            this.multiSelectIndex.splice(index, 1);
          }
        }
      });
      if (filteredNodes?.length == this.availableVMs.length) {
        this.isSelectAll = false;
      }
      return;
    }
  }

  checkSelectedCheckboxes(event, nodeName) {
    if (event.target.checked) {
      if (!this.multiSelectIndex.includes(nodeName)) {
        this.multiSelectIndex.push(nodeName);
        if (this.multiSelectIndex.length == this.availableVMs.length) {
          this.isSelectAll = true;
        }
      }
    } else {
      let idx = this.multiSelectIndex.indexOf(nodeName);
      this.multiSelectIndex.splice(idx, 1);
      if (
        this.multiSelectIndex.length == 0 ||
        this.multiSelectIndex.length != this.availableVMs.length
      ) {
        this.isSelectAll = false;
      }
    }
  }

  applyFilter() {
    this.filtersApplied = true;
    this.filteredWorkstations = this.availableVMs;
    if (this.filterText != "") {
      this.filteredWorkstations = this.filteredWorkstations.filter((nd) =>
        nd.vmNames.toLowerCase().includes(this.filterText.toLowerCase())
      );
    }
    return this.filteredWorkstations;
  }

  syncKvmVirtualMachines(){
    try{
      this.deploymentService.getHostsAndVmsFromKvm(this.depName, true).subscribe({
        next: (data) => {
          this._spinner.hide("attachNode");
          if(data){
            let objData = JSON.parse(JSON.stringify(data));
            if(objData) {
              this.availableVMs = objData?.kvmVirtualMachines;
              if(!this.availableVMs || this.availableVMs?.length == 0){
                this._snackBar.open("No virtual machines found.", "Ok", {
                  duration: 5000,
                });
              }
            }
          }
        },
        error: (err) => {
          this._spinner.hide("attachNode");
          console.error(err?.error);
          this._snackBar.open("Error fetching virtual machines.", "Ok", {
            duration: 5000,
          });
        },
      });
    }
    catch(err){
      this._spinner.hide("attachNode");
      console.error(err);
    }
  }
}
